import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useExportLevelDReport } from "../../hooks/leveld-reports/useExportLevelDReport";
import { LevelDReportFilter } from "../../types/leveld-reports";

interface LevelDExportButtonProps {
  filter: LevelDReportFilter;
}

export const LevelDExportButton: React.FC<LevelDExportButtonProps> = ({ filter }) => {
  const { t } = useTranslation();
  const { exportToExcel, isExporting } = useExportLevelDReport();

  return (
    <Tooltip title={t("levelDReports.export.tooltip")}>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        loading={isExporting}
        onClick={() => exportToExcel(filter)}
      >
        {t("levelDReports.export.button")}
      </Button>
    </Tooltip>
  );
};
